/**
 * /dashboard/maternity-cases/new — open a new maternity case
 * (G14 — POST /api/v1/maternity-cases).
 *
 * HR-admin only at the gate; the backend allows self-open too but the
 * SPA does not surface that path (an employee files her notice via
 * Leave Management → ML leave type; HR opens the matching case from
 * here).
 */

import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/shared/page-header";
import { MaternityRoleGate } from "@/components/maternity/maternity-role-gate";
import { CaseForm } from "@/components/maternity/case-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/maternity-cases/new",
)({
  component: NewMaternityCaseRoute,
});

function NewMaternityCaseRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <MaternityRoleGate>
      <PageHeader
        title="New Maternity Case"
        description="Record an employee's notice of intended maternity leave. Discharge protection (§12) is on by default."
      />
      <Card className="max-w-2xl">
        <CardContent className="pt-6">
          <CaseForm />
        </CardContent>
      </Card>
    </MaternityRoleGate>
  );
}
